import React from "react";
import { CSIData } from "../../types/csi";
import "./CSITable.scss";
import { Tooltip } from "antd";
import MarkdownParser from "../markdown";
import { Translate } from "react-redux-i18n";

interface CSITableProps {
  data: CSIData;
  className?: string;
}

export const CSITable: React.FC<CSITableProps> = ({ data, className }) => {
  if (!data.length) return null;

  const parameters = data.map((item) => item.parameterName);

  const criteriaLabels = Array.from(new Set(data.flatMap((param) => param.criterias.map((c) => c.label))));

  const valueMap = data.reduce((acc, param) => {
    param.criterias.forEach((criteria) => {
      acc[`${param.parameterName}-${criteria.label}`] = criteria.value;
    });
    return acc;
  }, {} as Record<string, number>);

  return (
    <div className={`csi-table-container ${className || ""}`}>
      <table className="csi-table">
        <thead>
          <tr>
            <th className="corner-header">
              <Translate value={"criteria_params"} />
            </th>
            {parameters.map((param, index) => (
              <th key={`param-${index}`}>
                <Tooltip title={param}>
                  <span className="truncated-text">
                    <MarkdownParser mixedString={param} />
                  </span>
                </Tooltip>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {criteriaLabels.map((criteria, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              <td className="criteria-label">
                <Tooltip title={criteria}>
                  <span className="truncated-text">{criteria}</span>
                </Tooltip>
              </td>
              {parameters.map((param, colIndex) => {
                const value = valueMap[`${param}-${criteria}`];
                return <td key={`cell-${rowIndex}-${colIndex}`}>{value !== undefined ? value.toFixed(2) : "-"}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
